// extracted by mini-css-extract-plugin
module.exports = {"formStyle":"contactForm-module--formStyle--2AVjt","feedbackInput":"contactForm-module--feedbackInput--AWSVv","textControl":"contactForm-module--textControl--cMx26"};